<div class="w-full px-8 flex justify-center bg-white py-4 lg:block hidden">
  <swiper-container
    class="w-full h-38"
    slides-per-view="1"
    loop="true"
    pagination="true"
    pagination-clickable="true"
    autoplay-delay="5000"
    autoplay-disable-on-interaction="false"
  >
    <swiper-slide>
      <div
        class="relative w-full h-38 bg-primary text-white rounded-md shadow flex items-center px-6"
      >
        <div class="flex flex-col justify-center w-8/12 ml-20">
          <h2 class="text-2xl font-extrabold mb-3">
            ¿Buscas trabajo o necesitas talento?
          </h2>
          <p class="text-sm opacity-90">
            Encuentra tu oportunidad laboral o publica una oferta para tu
            negocio hoy mismo.
          </p>
        </div>
        <img
          src="assets/icon/p2.png"
          alt="Publicidad Codijobs"
          class="absolute right-2 bottom-0 h-full object-contain"
        />
      </div>
    </swiper-slide>
    <swiper-slide>
      <div
        class="w-full py-8 h-38 bg-[#004481] flex items-center justify-center text-white rounded-md shadow px-6"
      >
        <img
          src="assets/icon/codideep.png"
          alt="Codideep Logo"
          class="h-full w-auto object-contain mr-6"
        />
        <a
          href="https://eirl.codideep.com"
          target="_blank"
          class="px-6 py-2 ml-20 border border-white text-white rounded-lg font-medium hover:bg-white hover:text-dark transition"
        >
          Explorar más proyectos
        </a>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div
        class="w-full h-38 rounded-md shadow flex items-center justify-center overflow-hidden"
        style="background-color: #1b77c7"
      >
        <a href="https://hosting.codideep.com" target="_blank">
          <img
            src="assets/icon/HOSTING.png"
            class="w-full cursor-pointer"
            alt="SYSEF logo"
          />
        </a>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div
        class="w-full h-38 rounded-md shadow flex items-center justify-center overflow-hidden"
        style="background-color: #1b77c7"
      >
        <a href="https://web.sysef.com" target="_blank">
          <img
            src="assets/icon/SYSEF.png"
            class="w-full cursor-pointer"
            alt="SYSEF logo"
          />
        </a>
      </div>
    </swiper-slide>
  </swiper-container>
</div>
